import { PrismicRichText } from "@prismicio/react";
import Styles from "./CenteredCta.module.css";
import { Button } from "@/components";

const CenteredCta = ({ primary }) => {
	return (
		<section
			className={Styles.wrapper}
			data-theme={primary?.dark_theme ? "dark" : "light"}
			data-padding-small-top={primary?.small_padding_top}
			data-padding-small-bottom={primary?.small_padding_bottom}
		>
			<div className={Styles.glow} aria-hidden="true"></div>
			<div className={Styles.container} data-contain="true">
				<PrismicRichText field={primary?.content} />
				{primary?.cta_label && primary?.cta_link && (
					<div className={Styles.btnContainer}>
						<Button link={primary?.cta_link} label={primary?.cta_label} />
					</div>
				)}
			</div>
		</section>
	);
};

export default CenteredCta;
